import { withStyles } from "@material-ui/core";
import React from "react";
import StyledTooltip from "../../StyledTooltip";
import { Edit } from "@material-ui/icons";
import { isPickupEditable } from "../../utils";
import { getPickupNumberIdListFromPickup } from "../../Pickups/GroupPickup/utils";

const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    maxWidth: "100%",
  },
  text: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  editIcon: {
    marginLeft: 8,
    marginTop: 2,
    cursor: "pointer",
    color: theme.iconColor,
    flexShrink: 0,
  },
});

const getDisplayLabel = (data, isBulkGroup) => {
  const list = getPickupNumberIdListFromPickup(data);
  const fromList = [...new Set(list.map((p) => p?.pickupNumber).filter(Boolean))].join(", ");
  if (fromList && isBulkGroup) {
    return fromList;
  }
  return data?.pickupNumber ?? "";
};

const PickupNumberRenderer = ({ classes, ...params }) => {
  const list = getPickupNumberIdListFromPickup(params.data);
  const pickupIds = list.map((p) => p?.pickupId).filter(Boolean);
  const isBulkGroup = pickupIds.length > 1 && params.context.isBulkEditAndVoidEnabled;
  const label = getDisplayLabel(params.data, isBulkGroup);
  if (!label) {
    return null;
  }
  const editable = isPickupEditable({
    isCompleted: params.data.isStopCompleted,
    isEnabled: params.context.isEditPickupEnabled,
  });
  const title = isBulkGroup ? "Edit group" : "Edit Pickup";

  const onEditClick = (e) => {
    e.stopPropagation();
    if (!pickupIds.length) {
      return;
    }
    if (isBulkGroup) {
      params.api.runCommand({
        action: "bulkEditPickup",
        pickupIds: pickupIds.map((id) => String(id).toUpperCase()),
      });
    } else {
      params.api.runCommand({
        action: "editPickup",
        pickupId: String(pickupIds[0]).toUpperCase(),
      });
    }
  };

  return (
    <div className={classes.container}>
      <span className={classes.text}>{label}</span>
      {editable ? (
        <StyledTooltip title={title}>
          <div>
            <Edit className={classes.editIcon} onClick={onEditClick} />
          </div>
        </StyledTooltip>
      ) : null}
    </div>
  );
};

export default withStyles(styles)(PickupNumberRenderer);
